<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="config().backgroundColor"
>
  <p
    class="completed-msg {{ environment.retailerName }}"
    [style.color]="config().completedMsg.color"
    [style.fontFamily]="config().completedMsg.fontFamily"
    [style.backgroundColor]="config().completedMsg.backgroundColor"
    [style.backgroundImage]="
      config().completedMsg.backgroundImage | transformUrl
    "
  >
    {{ config().completedMsg.text }}
  </p>

  <div
    class="reward-amount {{ environment.retailerName }}"
    [style.color]="config().rewardAmount.color"
    [style.fontFamily]="config().rewardAmount.fontFamily"
    [style.backgroundColor]="config().rewardAmount.backgroundColor"
  >
    @let pictureConfig = config().rewardAmount.picture;
    @if (config().rewardAmount.iconPosition === 'after') {
      <span [innerHTML]="amount() | formatReward | safe"></span>

      <img
        class="reward-amount-picture"
        [src]="pictureConfig.imageUrl"
        [alt]="pictureConfig.alternativeText"
        [style.width]="pictureConfig.width"
      />
    } @else {
      <img
        class="reward-amount-picture"
        [src]="pictureConfig.imageUrl"
        [alt]="pictureConfig.alternativeText"
        [style.width]="pictureConfig.width"
      />

      <span [innerHTML]="amount() | formatReward | safe"></span>
    }
  </div>

  <p
    class="voucher-msg {{ environment.retailerName }}"
    [style.color]="config().eVoucherMsg.color"
    [style.fontFamily]="config().eVoucherMsg.fontFamily"
  >
    {{ config().eVoucherMsg.text }}
  </p>
</div>
